import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MoveProductToStore } from './MoveProductToStore.jsx';

const productDataElements = document.querySelectorAll('.move-product-to-store-react');

if (!productDataElements.length) {
  console.log('No elements found for MoveProductToStore');
}

productDataElements.forEach((element) => {
  if (!element || element.dataset.reactMounted === 'true') {
    console.log('Element already mounted or invalid for MoveProductToStore:', element);
    return;
  }
  const storeName = element.getAttribute('data-store-name') || 'shared';
  const watchStoreChanges = element.getAttribute('data-watch-store-changes') === 'true';
  let productVariant = element.getAttribute('data-product-variant');
  let product = element.getAttribute('data-product');
  let bundleProductsHandle = element.getAttribute('data-bundle-products-handles');
  const discountPercentage = element.getAttribute('data-discount-percentage');

  try {
    productVariant = productVariant ? JSON.parse(productVariant) : null;
  } catch (error) {
    productVariant = null;
  }

  try {
    product = product ? JSON.parse(product) : null;
  } catch (error) {
    product = null;
  }

  if (bundleProductsHandle) {
    bundleProductsHandle = bundleProductsHandle
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);
  } else {
    bundleProductsHandle = null;
  }

  if (product) {
    product.productsHandle = bundleProductsHandle;
    product.discountPercentage = discountPercentage ? Number(discountPercentage) : null;
  }

  createRoot(element).render(
    <StrictMode>
      <MoveProductToStore
        storeName={storeName}
        watchStoreChanges={watchStoreChanges}
        productVariant={productVariant}
        product={product}
      />
    </StrictMode>,
  );
  element.dataset.reactMounted = 'true';
});
